export const mapComplianceToLabel = (val?: string | null) => {
  switch ((val || '').toString()) {
    case 'Compliant':
      return { label: 'Соответствует', className: 'match' }
    case 'Non_compliant':
      return { label: 'Не соответствует', className: 'no-match' }
    case 'Processing':
      return { label: 'Обработка', className: 'processing' }
    case 'Not_determined':
      return { label: 'Не размечено', className: 'not-labeled' }
    case 'Absent_model':
      return { label: 'Отсутствует модель', className: '' }
    default:
      return { label: val ?? '-', className: '' }
  }
}

export const formatAiPredictions = (item: any): string => {
  const aiRaw = item.ai_predictions ?? item.aiPredictions ?? []
  if (!Array.isArray(aiRaw) || aiRaw.length === 0) return ''

  return aiRaw
    .filter(
      (obj) => obj.percentage >= 0.1 && obj.type != null && obj.type !== '',
    )
    .map((obj) => String(obj.type))
    .filter(Boolean)
    .join(', ')
}

export const mapSourceToLabel = (val?: string | null) => {
  switch ((val || '').toString()) {
    case 'Imported':
      return 'Импортирован'
    case 'Dimension':
      return 'Замер'
    case 'Source':
      return 'Ссылка'
  }
}
